/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import Button from "components/ButtonUse";
import EditIcon from "@mui/icons-material/Edit";
import useSWR from "swr";
import arrowimg from "../../assets/images/arrowimg.png";
// import style from '../manageCategory/category.css';
import DownloadIcon from "@mui/icons-material/Download";
import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";
import * as XLSX from "xlsx";
import DoneIcon from "@mui/icons-material/Done";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import NoteAddIcon from "@mui/icons-material/Add";
// Dashboard components
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import LoaderComponent from "components/Loader";
import SnackBarComponent from "components/AlerComponent";
import { baseURL, baseUrl } from "utils/api";
import axios from "axios";
import ModalComponent from "components/ModalComponent";
import Select from "react-select";
import Rating from "@mui/material/Rating";

import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
function CategoryList() {
  const [rowModesModel, setRowModesModel] = useState({});
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setUpdatedRow(updatedRow);
    console.log(newRow);
    await handleUpdateCategory(newRow.id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedNewRow;
  };
//   const onRowsSelectionHandler = (ids) => {
//     const selectedRowsData = ids.map((id) => initialRows.find((row) => row.id === id));
//     const foundIds = selectedRowsData.map((d) => d.id);
//     setAllIds(foundIds);
//   };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can perform form submission logic here
    console.log("Form submitted:", formData);
    // After form submission, close the popup
    closePopup();
  };

  const reviewColumns = [
    {
      field: "storename",
      headerName: "Order Id",
      width: "180",
    },

    {
      field: "pNamed",
      headerName: "Customer Id",
      width: "180",
    },
   

    {
      field: "Datetime",
      headerName: "Store Id",
      width: 100,
    },
      ];

  const reviewRows = [
    {
      id: 1,
      pName: "Red Checked shirt",
      img: "test.png",
      ordDetails: "{orderid:123,location:Yangu,China}",
      skuId: "2468234",
      userId: "9983518525 , UserOne",
      unitPrice: 45,
      price: 60.5,
      quantity: 1,
      totalPrice: 89.5,
      mode: "Air",
      orderDate: "1 Aug 2023 hh:mm:ss",
      status: "Delivered 10 Sept 2023",
      // feedback:4
    },
    {
      id: 2,
      pName: "Red Checked shirt",
      img: "test.png",
      ordDetails: "{orderid:123,location:Yangu,China}",
      skuId: "2468234",
      userId: "9983518525 , UserOne",
      unitPrice: 45,
      price: 60.5,
      quantity: 1,
      totalPrice: 89.5,
      mode: "Air",
      orderDate: "1 Aug 2023 hh:mm:ss",
      status: "Returned 10 Sept 2023",
    },
    {
      id: 3,
      pName: "Red Checked shirt",
      img: "test.png",
      ordDetails: "{orderid:123,location:Yangu,China}",
      skuId: "2468234",
      userId: "9983518525 , UserOne",
      unitPrice: 45,
      price: 60.5,
      quantity: 1,
      totalPrice: 89.5,
      mode: "Air",
      orderDate: "1 Aug 2023 hh:mm:ss",
      status: "Exchange 10 Sept 2023",
    },
    {
      id: 4,
      pName: "Red Checked shirt",
      img: "test.png",
      ordDetails: "{orderid:123,location:Yangu,China}",
      skuId: "2468234",
      userId: "9983518525 , UserOne",
      unitPrice: 45,
      price: 60.5,
      quantity: 1,
      totalPrice: 89.5,
      mode: "Air",
      orderDate: "1 Aug 2023 hh:mm:ss",
      status: "Refunded 10 Sept 2023",
    },
    {
      id: 5,
      pName: "Red Checked shirt",
      img: "test.png",
      ordDetails: "{orderid:123,location:Yangu,China}",
      skuId: "2468234",
      userId: "9983518525 , UserOne",
      unitPrice: 45,
      price: 60.5,
      quantity: 1,
      totalPrice: 89.5,
      mode: "Air",
      orderDate: "1 Aug 2023 hh:mm:ss",
      status: "Delivered 10 Sept 2023",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {!data && <LoaderComponent open={true} />} */}
      <MDBox py={3}>
        <div>
          {/* <div className="flex">
            <label>
              <span
                type="button"
                className="bg-blue-700 rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                onClick={openPopup}
              >
                Approved
              </span>
            </label>

            <div className="flex">
              <label>
              
                <span
                  type="button"
                  className="bg-green-500  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Ignore
                </span>
              </label>
            </div>
          </div> */}

          {/* {isPopupOpen && (
            <div className="fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
              <div
                className="bg-white p-4 rounded-md"
                style={{ maxWidth: "800px", maxHeight: "100vh" }}
              >
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                      Product Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="4"
                      className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                      required
                    ></textarea>
                  </div>

                  <div className="flex justify-end">
                    <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded-md">
                      Submit
                    </button>
                    <button
                      onClick={closePopup}
                      className="bg-red-600 text-white px-4 py-2 rounded-md ml-4"
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )} */}
        </div>

        <Box sx={{ height:577, width: "100%", background: "white", marginTop: "3%" }}>
          <DataGrid
            rows={reviewRows}
            columns={reviewColumns}
            editMode="row"
            checkboxSelection={true}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            // onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            experimentalFeatures={{ newEditingApi: true }}
            // slots={{
            //   toolbar: EditToolbar,
            // }}
            // slotProps={{
            //   toolbar: { setRows, setRowModesModel },
            // }}
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CategoryList;